import { Flex, Icon, IconButton, Text, Tooltip } from "@chakra-ui/react";
import { RiMagicLine, RiQrScan2Line } from "react-icons/ri";
import type { Point } from "src/components/DocumentViewer/V2/types";
import type { Polygon } from "./utils/analyzeIdUtils";

export function IdentityDocumentMatchHint({
  documentMatchText,
  matchHighlights,
  onFindInDocument,
}: {
  documentMatchText: string;
  matchHighlights?: Polygon[];
  onFindInDocument?: (polygons: readonly (readonly Point[])[]) => void;
}) {
  return (
    <Flex align="center" flexWrap="wrap" gap={1} my={2}>
      <Icon as={RiMagicLine} color="purple.500" boxSize={5} flexShrink={0} />
      <Text as="span" fontSize="sm" color="purple.600" fontWeight="semibold">
        Document matches:
      </Text>
      <Text as="span" fontSize="sm" color="gray.800" fontWeight="normal">
        {documentMatchText}
      </Text>
      {onFindInDocument && matchHighlights?.length ? (
        <Tooltip label="Find in document" hasArrow>
          <IconButton
            aria-label="Find in document"
            icon={<Icon as={RiQrScan2Line} />}
            size="sm"
            variant="ghost"
            colorScheme="purple"
            onClick={() => {
              onFindInDocument(matchHighlights);
            }}
          />
        </Tooltip>
      ) : null}
    </Flex>
  );
}
